import classNames from 'classnames';
import type { Dayjs } from 'dayjs';
import { DailyInsectCountsStrip } from '@features/regional-overview/digital-traps/components/daily-insect-counts-strip/daily-insect-counts-strip.component';
import type { DynamicTrapRow } from '@features/regional-overview/digital-traps/domain';
import { DAILY_COUNTS_TRAP_SUMMARY_CARD } from '@features/regional-overview/digital-traps/domain/tests-id.constants';
import { DailyCountsCard } from '../daily-counts-card';
import styles from './daily-counts-trap-card.module.css';

export interface DailyCountsTrapCardProps {
  record: DynamicTrapRow;
  anchorDate: Dayjs;
  isFirstInGroup?: boolean;
}

export const DailyCountsTrapCard = ({ record, anchorDate, isFirstInGroup = true }: DailyCountsTrapCardProps) => (
  <DailyCountsCard
    trapName={record.name}
    trapId={record.id}
    total={record.total}
    status={record.status}
    contentClassName={classNames(styles.strip, { [styles.hideWebDateLabels]: !isFirstInGroup })}
    dataTestId={DAILY_COUNTS_TRAP_SUMMARY_CARD}>
    <DailyInsectCountsStrip dailyCounts={record.dailyInsectCounts ?? []} anchorDate={anchorDate} />
  </DailyCountsCard>
);
